import React, { useEffect, useRef } from "react";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";

import CssBaseline from "@mui/material/CssBaseline";
import {
  UserProfileProvider,
  UserProfileConsumer,
} from "../../common/ProfileContext";

import ProfileSummary from "../../sharedComponents/profileSummary/ProfileSummary";
import ProfileDetailsEditSectionContainer from "./ProfileDetailsEditSectionContainer";
import { Typography } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
  grid: {
    display: "flex",
    flexGrow: 1,
    flexWrap: "wrap",
    paddingTop: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.down("xs")]: {
      padding: 0,
    },
  },
  gridItem: {
    [theme.breakpoints.up("sm")]: {
      width: "100%",
      padding: theme.spacing(1),
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      paddingBottom: theme.spacing(2),
    },
  },
  profileSummary: {
    padding: theme.spacing(2),
    minHeight: "300px",
  },
  profileDetails: {
    color: theme.palette.text.secondary,
  },
}));

export default function CoachProfileEditMainContainer() {
  const classes = useStyles();

  return (
    <div className={classes.profileDetails}>
      <ProfileDetailsEditSectionContainer></ProfileDetailsEditSectionContainer>
    </div>
  );
}
